
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[pageId]",
      function () {
        return require("private-next-pages/page/[pageId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[pageId]"])
      });
    }
  